import dynamic from "next/dynamic";

export const Buttons = dynamic(() => import("./component"));
